// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { createAPINetworkInstance } from '../../../../common/api';

// Types
import { ActionGetClientAPI, getChatmeterSSOTokenSuccess, getChatmeterSSOTokenError, } from './actions';
import { SsoResponse } from './types';

function* getChatmeteSSOToken(action: ActionGetClientAPI) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `/chatmeterssotoken?username=${action.username}`);
        const response: SsoResponse = data;
        yield put(getChatmeterSSOTokenSuccess(response.ssoToken));
    } catch (err) {
        yield put(getChatmeterSSOTokenError(err));
    }
}

export default function* clientSagas() {
    yield takeLatest(ACTIONS.GET_CHATMETER_SSO_TOKEN, getChatmeteSSOToken);
}
